import React from "react";
import LegalPageLayout from "@/legal/LegalPageLayout";
import { OPERATOR, BRAND } from "@/legal/legalConfig";

export default function Terms() {
  return (
    <LegalPageLayout title="Allgemeine Geschäftsbedingungen (AGB)" lastUpdated="08.02.2026" testid="terms-page">
      <h2>1. Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für die Nutzung der von
        <strong> {OPERATOR.legal_name}</strong> ({OPERATOR.street}, {OPERATOR.zip} {OPERATOR.city}) betriebenen
        SaaS-Plattform {BRAND.name} durch Unternehmer im Sinne von § 14 BGB.
        Die Plattform richtet sich ausschließlich an gewerbliche Kunden, insbesondere PV-Betriebe,
        Solarteure und Marketing-Agenturen. Ein Vertragsschluss mit Verbrauchern ist ausgeschlossen.
      </p>

      <h2>2. Vertragsgegenstand</h2>
      <p>
        {BRAND.name} stellt eine cloudbasierte Software zur Lead-Erfassung, KI-gestützten Angebotserstellung,
        Nachfass-Automatisierung und Reporting für PV-Vertrieb bereit. Der konkrete Funktionsumfang ergibt sich aus
        dem jeweils gewählten Tarif. Wir sind berechtigt, den Funktionsumfang anzupassen, soweit dies für den Kunden zumutbar ist.
      </p>

      <h2>3. Vertragsschluss und Registrierung</h2>
      <p>
        Der Vertrag kommt mit Aktivierung des Nutzerkontos zustande. Der Kunde sichert zu, vollständige und wahrheitsgemäße
        Angaben zu machen. Zugangsdaten sind vertraulich zu behandeln; Weitergabe an Dritte ist untersagt.
      </p>

      <h2>4. Leistungserbringung und Verfügbarkeit</h2>
      <p>
        Wir bemühen uns um eine möglichst hohe Verfügbarkeit der Plattform. Ein Anspruch auf ununterbrochene Verfügbarkeit
        besteht nicht. Wartungsfenster werden, soweit möglich, in nutzungsarmen Zeiten angekündigt.
      </p>

      <h2>5. Preise und Zahlungsbedingungen</h2>
      <p>
        Die jeweils aktuellen Preise sind auf <a href={BRAND.homepage}>{BRAND.homepage}</a> ausgewiesen. Die Abrechnung erfolgt
        monatlich im Voraus über Stripe. Alle Preise verstehen sich netto zzgl. der gesetzlichen Mehrwertsteuer.
        Bei Zahlungsverzug behalten wir uns vor, den Zugang bis zur vollständigen Zahlung auszusetzen.
      </p>

      <h2>6. Laufzeit und Kündigung</h2>
      <p>
        Der Vertrag wird auf unbestimmte Zeit geschlossen und ist von beiden Parteien monatlich zum Ende des laufenden
        Abrechnungszeitraums kündbar — direkt im Stripe-Kundenportal oder per E-Mail an <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>.
        Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
      </p>

      <h2>7. Pflichten des Kunden</h2>
      <p>Der Kunde verpflichtet sich,</p>
      <ul>
        <li>geltende Gesetze (insbesondere DSGVO, UWG) bei der Nutzung der Plattform zu beachten,</li>
        <li>für jede über die Plattform versendete Nachricht eine zulässige Rechtsgrundlage sicherzustellen,</li>
        <li>keine Inhalte einzustellen, die Rechte Dritter oder geltendes Recht verletzen,</li>
        <li>uns und Dritte von Ansprüchen freizustellen, die aus einer rechtswidrigen Nutzung resultieren.</li>
      </ul>

      <h2>8. Datenschutz und Datensicherheit</h2>
      <p>
        Wir verarbeiten personenbezogene Daten gemäß unserer <a href="/datenschutz">Datenschutzerklärung</a>.
        Soweit der Kunde personenbezogene Daten Dritter (z.B. seiner Endkunden) über die Plattform verarbeitet,
        wird zwischen den Parteien ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO geschlossen.
      </p>

      <h2>9. Haftung</h2>
      <p>
        Wir haften unbeschränkt nur bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper und Gesundheit.
        Bei einfacher Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und beschränkt auf den
        vertragstypischen, vorhersehbaren Schaden. Eine darüber hinausgehende Haftung ist ausgeschlossen.
      </p>

      <h2>10. Schlussbestimmungen</h2>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
        Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten ist, soweit gesetzlich zulässig, {OPERATOR.city}.
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>
    </LegalPageLayout>
  );
}
